import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  Chip,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";

import MapPicker from "react-google-map-picker";
import GoogleAddressField from "app/components/google_address";
import DataTable from "theme/Tables/DataTable";
import { useAwaitDialog } from "app/components/status_dialog";
import * as XLSX from "xlsx";

function VisitTrackerPage() {
  const title = "Visit Tracker";
  usePageTitle(title);

  const { ref } = useParams();
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [locations, setLocations] = useState(0);
  const [locationGroups, setLocationGroups] = useState([]);
  const [activities, setActivities] = useState([]);
  const [dataForms, setDataForms] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [locationGroupsRaw, setLocationGroupsRaw] = useState([]);
  const [visitCount, setVisitCount] = useState(0);
  const [statesLgas, setStatesLgas] = useState([]);
  const [lgas, setLgas] = useState([]);

  const [trackerTitle, setTrackerTitle] = useState(null);

  const [locationTitle, setLocationTitle] = useState(null);
  const [locationPhoneNumber, setLocationPhoneNumber] = useState(null);
  const [locationAddress, setLocationAddress] = useState(null);
  const [locationState, setLocationState] = useState(null);
  const [locationLga, setLocationLga] = useState(null);
  const [locationCity, setLocationCity] = useState(null);
  const [locationLat, setLocationLat] = useState(null);
  const [locationLng, setLocationLng] = useState(null);
  const [locationRad, setLocationRad] = useState(100);
  const [centerLocation, setCenterLocation] = useState(null);
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [openEditLocationDialog, setOpenEditLocationDialog] = useState(false);
  const [addressType, setAddressType] = useState(null);

  const [activityTitle, setActivityTitle] = useState(null);
  const [selectedDataForm, setSelectedDataForm] = useState(null);
  const [openCreateActivityDialog, setOpenCreateActivityDialog] = useState(false);

  const [selectedLocationGroup, setSelectedLocationGroup] = useState(null);
  const [locationGroupTitle, setLocationGroupTitle] = useState(null);
  const [openLocationGroupDialog, setOpenLocationGroupDialog] = useState(false);

  const [uploadFile, setUploadFile] = useState(null);
  const [uploadAssignee, setUploadAssignee] = useState(null);
  const [openUploadLocationsDialog, setOpenUploadLocationsDialog] = useState(false);

  const [selectedAgentGroup, setSelectedAgentGroup] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);

  const [agentStaffNumber, setAgentStaffNumber] = useState(null);
  const [openDialogAssignAgent, setOpenDialogAssignAgent] = useState(false);
  const [openDialogAssignGroup, setOpenDialogAssignGroup] = useState(false);

  const [locationOverview, setLocationOverview] = useState(null);

  useEffect(() => {
    if (!locationState) {
      setLgas([]);
      return;
    }

    setLocationLga(null);
    const state = statesLgas.find((item) => item.reference === locationState);
    setLgas(state ? state.lgas : []);
  }, [locationState]);

  useEffect(() => {
    setLocationLat(null);
    setLocationLng(null);
  }, [addressType]);

  async function deleteActivity(activityRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/visits/trackers/activities/${activityRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateActivityStatus(activityRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/visits/trackers/activities/${activityRef}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const activitiesTableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Data Form", accessor: "data_form", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildActivitiesRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        data_form: row.data_form,
        actions: (
          <MDBox sx={{ width: "100%" }}>
            <MDBox mt={1} display="flex" gap={1}>
              <Tooltip title={row.status ? "Disable Activity" : "Enable Activity"}>
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={() => {
                    updateActivityStatus(row.reference);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    {row.status ? "pause" : "play_arrow"}
                  </Icon>
                </MDButton>
              </Tooltip>
              <Tooltip title="Delete Activity?">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete activity?`) === true) {
                      deleteActivity(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  async function deleteLocationGroup(locationRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/visits/trackers/location_groups/${locationRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const locationGroupsTableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Code", accessor: "code", align: "left" },
    { Header: "Agent Group", accessor: "agent_group", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildLocationGroupsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        code: row.code,
        agent_group: row.agent_group,
        actions: (
          <MDBox sx={{ width: "100%" }}>
            <MDBox mt={1} display="flex" justifyContent="space-evenly" alignItems="start">
              <Tooltip title="Delete Location Group?">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete location group?`) === true) {
                      deleteLocationGroup(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  async function deleteLocation(locationRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/visits/trackers/locations/${locationRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function getLocationReport(locationRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/visits/trackers/locations/${locationRef}/overview.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setLocationOverview(result.data.data.overview);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const locationsTableColumns = [
    { Header: "#", accessor: "check", align: "left" },
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Location Group", accessor: "location_group", align: "left" },
    // { Header: "Address", accessor: "address", align: "left" },
    { Header: "State", accessor: "state", align: "left" },
    { Header: "LGA", accessor: "lga", align: "left" },
    { Header: "Assigned", accessor: "assigned", align: "center" },
    // { Header: "Latitude", accessor: "latitude", align: "left" },
    // { Header: "Longitude", accessor: "longitude", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildLocationsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        check: (
          <Checkbox
            key={row.reference}
            onClick={(e) => {
              setSelectedLocations((prev) =>
                prev.includes(row.reference)
                  ? prev.filter((ref) => ref !== row.reference)
                  : [...prev, row.reference]
              );
            }}
          />
        ),
        title: row.title,
        location_group: row.location_group?.title ?? "---",
        assigned: (
          <Icon color={row.assigned ? "success" : "error"}>
            {row.assigned ? "check_circle" : "cancel"}
          </Icon>
        ),
        // latitude: row.latitude,
        // longitude: row.longitude,
        // address: row.address,
        state: row.state?.title ?? "---",
        lga: row.lga?.title ?? "---",
        actions: (
          <MDBox sx={{ width: "100%" }}>
            <MDBox mt={1} display="flex" gap={0.5}>
              <Tooltip title="Report Overview">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={() => {
                    getLocationReport(row.reference);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    bar_chart
                  </Icon>
                </MDButton>
              </Tooltip>
              {row.latitude && (
                <Tooltip title="View On Map">
                  <MDButton
                    size="small"
                    variant="outlined"
                    color="error"
                    iconOnly
                    onClick={() => {
                      const maplink = `https://maps.google.com?q=${row.latitude},${row.longitude}`;
                      window.open(maplink, "_blank");
                    }}
                  >
                    <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                      location_on
                    </Icon>
                  </MDButton>
                </Tooltip>
              )}
              <Tooltip title="Edit">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="warning"
                  iconOnly
                  onClick={() => {
                    setSelectedLocation(row);
                    setLocationTitle(row.title);
                    // setLocationLat(row.latitude);
                    // setLocationLng(row.longitude);
                    setLocationAddress(row.address);
                    setSelectedLocationGroup(row.location_group?.reference);
                    setLocationPhoneNumber(row.phone_number);
                    setLocationCity(row.city);
                    setLocationState(row.state?.reference);
                    setLocationLga(row.lga?.reference);
                    setAddressType(null);
                    setCenterLocation(null);
                    setOpenEditLocationDialog(true);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    edit
                  </Icon>
                </MDButton>
              </Tooltip>
              <Tooltip title="Delete Location?">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete location?`) === true) {
                      deleteLocation(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/visits/trackers/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setTrackerTitle(result.data.data.tracker.title);
            setLocationGroupsRaw(result.data.data.location_groups);
            setAgentGroups(result.data.data.agent_groups);
            setDataForms(result.data.data.data_forms);
            setVisitCount(result.data.data.visitCount);
            setStatesLgas(result.data.data.states_lgas);

            const locationGroupRows = buildLocationGroupsRows(result.data.data.location_groups);
            setLocationGroups(locationGroupRows);

            const activitiesRows = buildActivitiesRows(result.data.data.activities);
            setActivities(activitiesRows);

            const locationRows = buildLocationsRows(result.data.data.locations);
            setLocations(locationRows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function onLocationPicked(clat, clng) {
    setLocationLat(clat);
    setLocationLng(clng);
  }

  useEffect(() => {
    if (locationLat === null) {
      return;
    }

    if (locationLng === null) {
      return;
    }

    setCenterLocation({
      lat: locationLat,
      lng: locationLng,
    });
  }, [locationLat, locationLng]);

  async function createLocationGroup() {
    if (locationGroupTitle === null) {
      setSeverity("error");
      setErrMsg("A location group name is required.");
      setOpen(true);
      return;
    }

    setOpenLocationGroupDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: locationGroupTitle,
      group: selectedAgentGroup,
    };

    await axios
      .post("portal/visits/trackers/location_groups/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createLocation() {
    if (locationTitle === null) {
      setSeverity("error");
      setErrMsg("A location name is required.");
      setOpen(true);
      return;
    }

    if (locationAddress === null) {
      setSeverity("error");
      setErrMsg("A location address is required.");
      setOpen(true);
      return;
    }

    if (addressType === "google") {
      if (locationLat === null) {
        setSeverity("error");
        setErrMsg("Location latitude is required");
        setOpen(true);
        return;
      }

      if (locationLng === null) {
        setSeverity("error");
        setErrMsg("Location longitude is required");
        setOpen(true);
        return;
      }

      if (locationRad === null) {
        setSeverity("error");
        setErrMsg("Location area radius is required");
        setOpen(true);
        return;
      }
    }

    if (locationCity === null) {
      setSeverity("error");
      setErrMsg("City is required");
      setOpen(true);
      return;
    }

    if (locationState === null) {
      setSeverity("error");
      setErrMsg("State is required");
      setOpen(true);
      return;
    }

    if (locationLga === null) {
      setSeverity("error");
      setErrMsg("LGA is required");
      setOpen(true);
      return;
    }

    setOpenLocationDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: locationTitle,
      address: locationAddress,
      phone_number: locationPhoneNumber,
      latitude: locationLat,
      longitude: locationLng,
      location_group: selectedLocationGroup,
      city: locationCity,
      state: locationState,
      lga: locationLga,
    };

    console.log(json);

    await axios
      .post("portal/visits/trackers/locations/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editLocation() {
    if (locationTitle === null) {
      setSeverity("error");
      setErrMsg("A location name is required.");
      setOpen(true);
      return;
    }

    if (locationAddress === null) {
      setSeverity("error");
      setErrMsg("A location address is required.");
      setOpen(true);
      return;
    }

    if (locationCity === null) {
      setSeverity("error");
      setErrMsg("City is required.");
      setOpen(true);
      return;
    }

    if (locationState === null) {
      setSeverity("error");
      setErrMsg("State is required.");
      setOpen(true);
      return;
    }

    if (locationLga === null) {
      setSeverity("error");
      setErrMsg("LGA is required.");
      setOpen(true);
      return;
    }

    // if (locationLat === null) {
    //   setSeverity("error");
    //   setErrMsg("Location latitude is required");
    //   setOpen(true);
    //   return;
    // }

    // if (locationLng === null) {
    //   setSeverity("error");
    //   setErrMsg("Location longitude is required");
    //   setOpen(true);
    //   return;
    // }

    setOpenEditLocationDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedLocation.reference,
      title: locationTitle,
      address: locationAddress,
      phone_number: locationPhoneNumber,
      latitude: locationLat,
      longitude: locationLng,
      location_group: selectedLocationGroup,
      city: locationCity,
      state: locationState,
      lga: locationLga,
    };

    await axios
      .post("portal/visits/trackers/locations/edit.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createActivity() {
    if (activityTitle === null) {
      setSeverity("error");
      setErrMsg("Activity name is required.");
      setOpen(true);
      return;
    }

    if (selectedDataForm === null) {
      setSeverity("error");
      setErrMsg("Data form is required.");
      setOpen(true);
      return;
    }

    setOpenCreateActivityDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: activityTitle,
      data_form: selectedDataForm,
    };

    await axios
      .post("portal/visits/trackers/activities/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignToLocationGroup() {
    if (selectedLocationGroup === null) {
      setSeverity("error");
      setErrMsg("Location group is required.");
      setOpen(true);
      return;
    }

    if (!selectedLocations) {
      setSeverity("error");
      setErrMsg("A selected locations is required.");
      setOpen(true);
      return;
    }

    setOpenDialogAssignGroup(false);
    setShowLoading(true);
    const json = {
      locations: selectedLocations,
      reference: selectedLocationGroup,
    };

    console.log(json);

    await axios
      .post("portal/visits/trackers/locations/assign_location_group.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignToAgent() {
    if (agentStaffNumber === null) {
      setSeverity("error");
      setErrMsg("Agent staff number is required.");
      setOpen(true);
      return;
    }

    if (!selectedLocations) {
      setSeverity("error");
      setErrMsg("A selected locations is required.");
      setOpen(true);
      return;
    }

    setOpenDialogAssignAgent(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      type: "agent",
      locations: selectedLocations,
      assignee: agentStaffNumber,
    };

    await axios
      .post("portal/visits/trackers/locations/assign.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function fileSelected(e) {
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      if (!json.length) {
        throw new Error("Empty file");
      }

      // First row = headers
      const headers = json[0].map((h) => String(h).toLowerCase().trim());
      const requiredColumns = ["name", "phone_number"];
      const missing = requiredColumns.filter((col) => !headers.includes(col));
      if (missing.length > 0) {
        setSeverity("error");
        setErrMsg(`Missing required columns: ${missing.join(", ")}`);
        setOpen(true);
        return;
      }

      setUploadFile(file);
    } catch (err) {
      setSeverity("error");
      setErrMsg("Invalid or unreadable file.");
      setOpen(true);
    }
  }

  async function uploadLocations() {
    if (!uploadFile) {
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (selectedLocationGroup) {
      formData.append("location_group", selectedLocationGroup);
    }

    if (agentStaffNumber) {
      formData.append("agent", agentStaffNumber);
    }

    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadLocationsDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/visits/trackers/locations/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {locationOverview && (
        <Dialog open={!!locationOverview} fullWidth maxWidth="sm">
          <DialogTitle sx={{ pb: 1 }}>
            <MDTypography align="center" variant="h5" fontWeight="bold">
              Location Overview
            </MDTypography>
          </DialogTitle>

          <DialogContent>
            <MDBox>
              <MDBox
                p={2}
                mb={3}
                borderRadius="lg"
                sx={{
                  background: "#fafafa",
                  border: "1px solid #ececec",
                }}
              >
                <MDTypography variant="caption" color="text">
                  LOCATION
                </MDTypography>
                <MDTypography variant="h5" fontWeight="bold">
                  {locationOverview.title}
                </MDTypography>

                <MDTypography mt={3} variant="body2" color="text" fontSize={13}>
                  ASSIGNED TO
                </MDTypography>
                <MDBox display="flex" alignItems="center">
                  <Icon
                    sx={{
                      fontSize: 18,
                      color: "#757575",
                      mr: 1,
                    }}
                  >
                    person
                  </Icon>

                  <MDTypography variant="button" color="text" fontWeight="regular">
                    {locationOverview.assigned_to}
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="uppercase"
                color="text"
              >
                Visit Breakdown
              </MDTypography>
              <Grid container spacing={2} mt={0.5} mb={3}>
                <Grid item xs={6}>
                  <MDBox
                    p={2}
                    borderRadius="lg"
                    sx={{
                      border: "1px solid #ececec",
                      textAlign: "center",
                    }}
                  >
                    <Icon fontSize="small">tour</Icon>

                    <MDTypography mt={1} variant="h6" fontWeight="bold">
                      {locationOverview.visits.count}
                    </MDTypography>

                    <MDTypography variant="caption" color="text">
                      Check Ins
                    </MDTypography>
                  </MDBox>
                </Grid>

                <Grid item xs={6}>
                  <MDBox
                    p={2}
                    borderRadius="lg"
                    sx={{
                      border: "1px solid #ececec",
                      textAlign: "center",
                    }}
                  >
                    <Icon fontSize="small">schedule</Icon>

                    <MDTypography mt={1} variant="h6" fontWeight="bold">
                      {locationOverview.visits.last ?? "---"}
                    </MDTypography>

                    <MDTypography variant="caption" color="text">
                      Last Check In
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>

              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="uppercase"
                color="text"
              >
                Activity Breakdown
              </MDTypography>

              <MDBox mt={2}>
                {locationOverview.activities.length > 0 ? (
                  <>
                    {locationOverview.activities.map((activity) => (
                      <MDBox
                        key={activity.activity}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        py={1.5}
                        px={2}
                        mb={1}
                        borderRadius="md"
                        sx={{
                          border: "1px solid #ececec",
                        }}
                      >
                        <MDBox display="flex" alignItems="center">
                          <Icon
                            sx={{
                              fontSize: 18,
                              mr: 1.5,
                              color: "#757575",
                            }}
                          >
                            assignment
                          </Icon>

                          <MDTypography variant="button">{activity.activity}</MDTypography>
                        </MDBox>

                        <Chip label={activity.count} size="small" />
                      </MDBox>
                    ))}
                  </>
                ) : (
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    py={1.5}
                    px={2}
                    mb={1}
                    borderRadius="md"
                    sx={{
                      border: "1px solid #ececec",
                    }}
                  >
                    <MDTypography variant="button">No activity done yet</MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton
              color="dark"
              variant="outlined"
              startIcon={<Icon>close</Icon>}
              onClick={() => setLocationOverview(null)}
            >
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      )}

      <Dialog open={openUploadLocationsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Locations</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1} mb={3}>
            <MDBox>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={1}>
              <Alert severity="warning">
                <MDTypography variant="subtitle2" fontSize={14}>
                  Your file must contain <b>name</b>, <b>address</b>, <b>state</b> and <b>lga</b>{" "}
                  columns.
                </MDTypography>
              </Alert>
            </MDBox>

            <MDBox mt={4}>
              <MDInput
                select
                label="Assign To (Optional)"
                onChange={(e) => {
                  if (e.target.value === "agent") {
                    setSelectedLocationGroup(null);
                  } else {
                    setAgentStaffNumber(null);
                  }
                  setUploadAssignee(e.target.value);
                }}
                fullWidth
                SelectProps={{ style: { padding: "12px 0px" } }}
              >
                <MenuItem value="location_group">Location Group</MenuItem>
                <MenuItem value="agent">Agent</MenuItem>
              </MDInput>
            </MDBox>

            {uploadAssignee === "location_group" && (
              <MDBox mt={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Location Group</InputLabel>
                  <Select
                    label="Location Group"
                    onChange={(e) => {
                      setSelectedLocationGroup(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value={null}>Select Location Group</MenuItem>
                    {
                      // --> Notice below changes
                      locationGroupsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        locationGroupsRaw.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}

            {uploadAssignee === "agent" && (
              <MDBox mt={3}>
                <MDInput
                  name="title"
                  margin="dense"
                  label="Agent Staff Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setAgentStaffNumber(e.target.value)}
                />
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadLocationsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadLocations();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openLocationDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Location</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={0}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Location Group (Optional)</InputLabel>
                <Select
                  label="Location Group (Optional)"
                  onChange={(e) => {
                    setSelectedLocationGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value={null}>Select Location Group</MenuItem>
                  {
                    // --> Notice below changes
                    locationGroupsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      locationGroupsRaw.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                name="title"
                margin="dense"
                label="Location Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Phone Number (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationPhoneNumber(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3} px={1}>
              <MDTypography
                variant="button"
                fontWeight="medium"
                color="text"
                mb={1}
                display="block"
              >
                Address Type
              </MDTypography>

              <RadioGroup value={addressType} onChange={(e) => setAddressType(e.target.value)}>
                <FormControlLabel
                  value="google"
                  control={<Radio size="small" />}
                  label={
                    <MDTypography fontSize={14} fontWeight={300}>
                      Search on Google Maps (Recommended)
                    </MDTypography>
                  }
                />

                <FormControlLabel
                  value="manual"
                  control={<Radio size="small" />}
                  label={
                    <MDTypography fontSize={14} fontWeight={300}>
                      Enter Address Manually (No GPS Accuracy)
                    </MDTypography>
                  }
                />
              </RadioGroup>
            </MDBox>
            {addressType === "google" && (
              <MDBox>
                <MDBox mt={1}>
                  <MDBox>
                    <GoogleAddressField
                      displayName="Search Address On Google Maps"
                      setAddress={setLocationAddress}
                      setLatitude={setLocationLat}
                      setLongitude={setLocationLng}
                      defaultAddress={locationAddress}
                    />
                  </MDBox>
                </MDBox>
                {centerLocation !== null && (
                  <MDBox mt={3} mb={3}>
                    <div style={{ height: "30vh", width: "100%" }}>
                      <MDBox>
                        <MapPicker
                          defaultLocation={centerLocation}
                          zoom={18}
                          mapTypeId="roadmap"
                          style={{ height: "30vh" }}
                          onChangeLocation={(lat, lng) => {
                            onLocationPicked(lat, lng);
                          }}
                          apiKey={AppConfig.google_map_key}
                        />
                      </MDBox>
                    </div>
                  </MDBox>
                )}
              </MDBox>
            )}

            {addressType === "manual" && (
              <MDBox mt={2}>
                <MDBox>
                  <MDInput
                    label="Address"
                    multiline
                    rows={2}
                    fullWidth
                    value={locationAddress}
                    onChange={(e) => setLocationAddress(e.target.value)}
                  />
                </MDBox>
              </MDBox>
            )}
            <MDBox mt={3}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <MDInput
                    select
                    label="State"
                    onChange={(e) => {
                      setLocationState(e.target.value);
                    }}
                    fullWidth
                    SelectProps={{ style: { padding: "12px 0px" } }}
                  >
                    {
                      // --> Notice below changes
                      statesLgas.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        statesLgas.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </MDInput>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    select
                    label="LGA"
                    onChange={(e) => {
                      setLocationLga(e.target.value);
                    }}
                    fullWidth
                    SelectProps={{ style: { padding: "12px 0px" } }}
                  >
                    {
                      // --> Notice below changes
                      lgas.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        lgas.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </MDInput>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    label="City"
                    fullWidth
                    value={locationCity}
                    onChange={(e) => setLocationCity(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenLocationDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createLocation();
            }}
          >
            Add Location
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditLocationDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Location</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={0}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Location Group (Optional)</InputLabel>
                <Select
                  label="Location Group (Optional)"
                  onChange={(e) => {
                    setSelectedLocationGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  value={selectedLocationGroup}
                >
                  <MenuItem value={null}>Select Location Group</MenuItem>
                  {
                    // --> Notice below changes
                    locationGroupsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      locationGroupsRaw.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={locationTitle}
                name="title"
                margin="dense"
                label="Location Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={locationPhoneNumber}
                name="title"
                margin="dense"
                label="Phone Number (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationPhoneNumber(e.target.value)}
              />
            </MDBox>
            {addressType !== "google" && (
              <MDBox mt={2} display="flex" gap={1}>
                <MDInput
                  value={locationAddress}
                  name="title"
                  margin="dense"
                  label="Address"
                  type="text"
                  fullWidth
                  variant="outlined"
                  readOnly
                />
                <MDButton startIcon={<Icon>edit</Icon>} onClick={() => setAddressType("google")}>
                  Edit
                </MDButton>
              </MDBox>
            )}

            {addressType === "google" && (
              <MDBox mt={2} display="flex" gap={1}>
                <GoogleAddressField
                  displayName="Search Address On Google Maps"
                  setAddress={setLocationAddress}
                  setLatitude={setLocationLat}
                  setLongitude={setLocationLng}
                />
                <MDButton startIcon={<Icon>cancel</Icon>} onClick={() => setAddressType(null)}>
                  Cancel
                </MDButton>
              </MDBox>
            )}
            {/* <MDBox mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    name="title"
                    margin="dense"
                    label="Latitude"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={locationLat ?? ""}
                    onChange={(e) => setLocationLat(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    name="title"
                    margin="dense"
                    label="Longitude"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={locationLng ?? ""}
                    onChange={(e) => setLocationLng(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={4}>
                <MDInput
                  select
                  label="State"
                  onChange={(e) => {
                    setLocationState(e.target.value);
                  }}
                  fullWidth
                  SelectProps={{ style: { padding: "12px 0px" } }}
                  value={locationState}
                >
                  {
                    // --> Notice below changes
                    statesLgas.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      statesLgas.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </MDInput>
              </Grid>
              <Grid item xs={4}>
                <MDInput
                  select
                  label="LGA"
                  onChange={(e) => {
                    setLocationLga(e.target.value);
                  }}
                  fullWidth
                  SelectProps={{ style: { padding: "12px 0px" } }}
                  value={locationLga}
                >
                  {
                    // --> Notice below changes
                    lgas.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      lgas.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </MDInput>
              </Grid>
              <Grid item xs={4}>
                <MDInput
                  label="City"
                  fullWidth
                  value={locationCity}
                  onChange={(e) => setLocationCity(e.target.value)}
                />
              </Grid>
            </Grid>
            {centerLocation !== null && (
              <MDBox mt={5} mb={3}>
                <div style={{ height: "50vh", width: "100%" }}>
                  <MDBox>
                    <MapPicker
                      defaultLocation={centerLocation}
                      zoom={18}
                      mapTypeId="roadmap"
                      style={{ height: "50vh" }}
                      onChangeLocation={(lat, lng) => {
                        onLocationPicked(lat, lng);
                      }}
                      apiKey={AppConfig.google_map_key}
                    />
                  </MDBox>
                </div>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditLocationDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              editLocation();
            }}
          >
            Update
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openLocationGroupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Location Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationGroupTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                select
                label="Assigned Agent Group"
                onChange={(e) => {
                  setSelectedAgentGroup(e.target.value);
                }}
                fullWidth
                SelectProps={{ style: { padding: "12px 0px" } }}
              >
                {
                  // --> Notice below changes
                  agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                    agentGroups.map((record) => (
                      <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                    ))
                }
              </MDInput>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenLocationGroupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createLocationGroup();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openCreateActivityDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Activity</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                name="title"
                margin="dense"
                label="Activity Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setActivityTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Attach Data Form</InputLabel>
                <Select
                  label="Attach Data Form"
                  onChange={(e) => {
                    setSelectedDataForm(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  placeholder="Select a data form"
                  value={selectedDataForm}
                >
                  <MenuItem value={null}>Select Data Form</MenuItem>
                  {
                    // --> Notice below changes
                    dataForms.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataForms.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateActivityDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createActivity();
            }}
          >
            Create Activity
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openDialogAssignAgent} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign To Agent</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                name="title"
                margin="dense"
                label="Agent Staff Number"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setAgentStaffNumber(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenDialogAssignAgent(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignToAgent();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openDialogAssignGroup} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add To Location Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <MDInput
                select
                label="Location Group"
                onChange={(e) => {
                  setSelectedLocationGroup(e.target.value);
                }}
                fullWidth
                SelectProps={{ style: { padding: "12px 0px" } }}
              >
                {
                  // --> Notice below changes
                  locationGroupsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                    locationGroupsRaw.map((record) => (
                      <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                    ))
                }
              </MDInput>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenDialogAssignGroup(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignToLocationGroup();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      {pageLoaded && (
        <MDBox mb={5}>
          <MDBox mt={1} mb={1} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/visits/trackers`);
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox>
              <Button
                color="dark"
                size="small"
                onClick={() => {
                  navigate(`/visits/trackers/${ref}/activity/logs`);
                }}
                startIcon={<Icon>list</Icon>}
              >
                Activity Logs
              </Button>
              <Button
                color="dark"
                size="small"
                onClick={() => navigate(`/visits/trackers/${ref}/visit/logs`)}
                startIcon={<Icon>list</Icon>}
              >
                Check Ins
              </Button>
            </MDBox>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox sx={{ height: "100%" }}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2}>
                    <MDBox>
                      <MDTypography variant="h6">Tracker Information</MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDInput
                        value={trackerTitle}
                        name="title"
                        margin="dense"
                        label="Tracker Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setTrackerTitle(e.target.value)}
                      />
                    </MDBox>
                    {/* <MDBox mt={3} align="right">
                      <MDButton
                        color="dark"
                        variant="contained"
                        onClick={() => {
                          editCampaign();
                        }}
                      >
                        Save Changes
                      </MDButton>
                    </MDBox> */}
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox sx={{ height: "100%" }}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={28}>
                        <Icon color="dark">pin_drop</Icon>
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDTypography variant="h6" fontSize={28}>
                        {locations.length}
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDTypography variant="h6" fontWeight="light">
                        Locations
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <MDBox sx={{ height: "100%" }}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={28}>
                        <Icon color="dark">tour</Icon>
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDTypography variant="h6" fontSize={28}>
                        {visitCount}
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDTypography variant="h6" fontWeight="light">
                        Check Ins
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
          </Grid>
          <MDBox mt={5}>
            {locationGroups.length > 0 ? (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium">
                            Location Groups
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            size="small"
                            onClick={() => {
                              setLocationGroupTitle(null);
                              setOpenLocationGroupDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      <DataTable
                        table={{ columns: locationGroupsTableColumns, rows: locationGroups }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            ) : (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon>workspaces</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                          Organise customer locations into groups.
                          <br />
                          Add customer locations to each group and assign Location groups to your
                          team.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5} mb={3}>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            setLocationGroupTitle(null);
                            setOpenLocationGroupDialog(true);
                          }}
                          startIcon={<Icon>add</Icon>}
                        >
                          Add Location Group
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>

          <MDBox mt={5}>
            {activities.length > 0 ? (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium">
                            Activities
                          </MDTypography>
                        </MDBox>
                        <MDBox display="flex" gap={0.8}>
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            size="small"
                            onClick={() => {
                              setActivityTitle(null);
                              setSelectedDataForm(null);
                              setOpenCreateActivityDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                          {/* <Tooltip title="Activity Logs">
                            <MDButton
                              variant="contained"
                              color="info"
                              iconOnly
                              size="small"
                              onClick={() => {
                                navigate(`/visits/trackers/${ref}/activity/logs`);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>list</Icon>
                            </MDButton>
                          </Tooltip> */}
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      <DataTable
                        table={{ columns: activitiesTableColumns, rows: activities }}
                        isSorted
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            ) : (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon>edit_note</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                          Create customizable activities your agents will be required to perform
                          for/at each customer location. From sales orders. merchandising. customer
                          feedback and much more.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={3} mb={3}>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            setActivityTitle(null);
                            setSelectedDataForm(null);
                            setOpenCreateActivityDialog(true);
                          }}
                          startIcon={<Icon>add</Icon>}
                        >
                          Create Activity
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>

          <MDBox mt={5}>
            {locations.length > 0 ? (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium">
                            Locations
                          </MDTypography>
                        </MDBox>
                        <MDBox display="flex" gap={0.8}>
                          <MDButton
                            variant="contained"
                            color="dark"
                            size="small"
                            iconOnly
                            onClick={() => {
                              setLocationTitle(null);
                              setLocationPhoneNumber(null);
                              setLocationLat(null);
                              setLocationLng(null);
                              setSelectedLocationGroup(null);
                              setCenterLocation(null);
                              setLocationAddress(null);
                              setLocationCity(null);
                              setLocationState(null);
                              setLocationLga(null);
                              setOpenLocationDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                          <MDButton
                            size="small"
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setSelectedLocationGroup(null);
                              setAgentStaffNumber(null);
                              setUploadFile(null);
                              setOpenUploadLocationsDialog(true);
                            }}
                          >
                            <Icon>upload</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    {selectedLocations.length > 0 && (
                      <MDBox mt={1} px={2}>
                        <Alert severity="info">
                          <MDTypography variant="body2" fontSize={13}>
                            {selectedLocations.length} location(s) selected
                          </MDTypography>
                          <MDBox display="flex" gap={0.8} mt={2}>
                            <MDButton
                              color="dark"
                              size="small"
                              startIcon={<Icon>person</Icon>}
                              onClick={() => {
                                setAgentStaffNumber(null);
                                setOpenDialogAssignAgent(true);
                              }}
                            >
                              Assign to agent
                            </MDButton>
                            <MDButton
                              color="dark"
                              size="small"
                              startIcon={<Icon>place</Icon>}
                              onClick={() => {
                                setSelectedAgentGroup(null);
                                setOpenDialogAssignGroup(true);
                              }}
                            >
                              Add to location group
                            </MDButton>
                          </MDBox>
                        </Alert>
                      </MDBox>
                    )}
                    <MDBox>
                      <DataTable
                        table={{ columns: locationsTableColumns, rows: locations }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            ) : (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon>pin_drop</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                          Add or upload customer locations. Supports both GPS enabled and manual
                          addresses.
                          <br />
                          Non-GPS enabled locations are automatically resolved to accurate GPS
                          cordinates based on agent visits.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5} mb={3} display="flex" gap={1} justifyContent="center">
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            setLocationTitle(null);
                            setLocationPhoneNumber(null);
                            setLocationLat(null);
                            setLocationLng(null);
                            setSelectedLocationGroup(null);
                            setCenterLocation(null);
                            setLocationAddress(null);
                            setLocationCity(null);
                            setLocationState(null);
                            setLocationLga(null);
                            setOpenLocationDialog(true);
                          }}
                          startIcon={<Icon>add</Icon>}
                        >
                          Add
                        </MDButton>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            setSelectedLocationGroup(null);
                            setAgentStaffNumber(null);
                            setUploadFile(null);
                            setOpenUploadLocationsDialog(true);
                          }}
                          startIcon={<Icon>upload</Icon>}
                        >
                          Upload
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        </MDBox>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default VisitTrackerPage;
